import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  card: {
    position: 'relative',
    padding: 20,
    textAlign: 'center',
    marginBottom: 20,
    minHeight: 350,
    border: '1px solid #ddd',
    borderRadius: 8,
    boxShadow: 'unset'
  },
  cardTitle: {
    textAlign: 'center',
    fontFamily: 'Roboto',
    fontSize: '1.4em',
    fontWeight: 100
  },
  cardDescription: {
    textAlign: 'center',
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 100
  },
  sort: {
    cursor: 'move',
    position: 'absolute',
    left: 20,
    top: 20
  },
  spand: {
    cursor: 'pointer',
    position: 'absolute',
    right: 20,
    top: 20
  },
  info: {
    cursor: 'pointer',
    position: 'absolute',
    right: 20,
    bottom: 20
  },
  infoOverlay: {
    zIndex: 2,
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0
  },
  overlayOpacity: {
    background: '#efefef',
    opacity: '0.9',
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0
  },
  textContainer: {
    position: 'absolute',
    left: 0,
    width: '100%',
    top: '50%',
    transform: 'translateY(-50%)',
    padding: 20
  },
  label: {
    fontSize: '2.5em',
    color: '#d45113',
    fontFamily: 'Roboto',
    fontWeight: 300
  },
  divider: {
    marginBottom: 20
  },
  noBorder: {
    border: 'none',
    boxShadow: 'none'
  }
});

export default useStyles;
